import { Link as RouterLink, useLocation } from "react-router-dom";
import { Mui, MuiIcons } from "@leap4/frontend";
import { urlService } from "../routing/urlsService";
import { useCampaignScope } from "../scope/CampaignScopeProvider";

const { List, ListItemButton, ListItemIcon, ListItemText, Tooltip } = Mui;
const { Dashboard, TrendingUp, Assessment } = MuiIcons;

const NAV_ITEMS = [
    { label: "Dashboard", path: urlService.dashboard(), icon: Dashboard },
    { label: "Projection", path: urlService.projection(), icon: TrendingUp },
    { label: "Reporting", path: urlService.reporting(), icon: Assessment },
];

interface ISidebarNavigationProps {
    collapsed: boolean;
    onNavigate?: () => void;
}

export const SidebarNavigation = ({ collapsed, onNavigate }: ISidebarNavigationProps) => {
    const { pathname } = useLocation();
    const { projectionEnabled } = useCampaignScope();
    // "/" renders the dashboard, so it is the dashboard's active state too.
    const isActive = (path: string) => pathname === path || (pathname === "/" && path === urlService.dashboard());

    return (
        <List component="nav" aria-label="Main navigation" disablePadding sx={{ px: 1 }}>
            {NAV_ITEMS.filter((item) => item.path !== urlService.projection() || projectionEnabled).map(({ label, path, icon: Icon }) => {
                const active = isActive(path);
                const button = (
                    <ListItemButton
                        key={path}
                        component={RouterLink}
                        to={path}
                        selected={active}
                        aria-current={active ? "page" : undefined}
                        aria-label={collapsed ? label : undefined}
                        onClick={onNavigate}
                        sx={{ mb: 0.5, minHeight: 44, justifyContent: collapsed ? "center" : "flex-start" }}
                    >
                        <ListItemIcon sx={{ minWidth: collapsed ? 0 : 40, justifyContent: "center" }}>
                            <Icon />
                        </ListItemIcon>
                        {!collapsed && <ListItemText primary={label} />}
                    </ListItemButton>
                );
                return collapsed ? (
                    <Tooltip key={path} title={label} placement="right">
                        {button}
                    </Tooltip>
                ) : (
                    button
                );
            })}
        </List>
    );
};
